import React, { SVGProps } from 'react'
const SvgLightningBolt = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="m4.113 7.987 3.26-4.424c.324-.44 1.011-.206 1.011.343v2.746c0 .316.252.572.562.572h2.491c.453 0 .72.516.463.896l-2.903 4.298c-.312.463-1.025.237-1.025-.324v-2.62a.567.567 0 0 0-.562-.572H4.563c-.463 0-.727-.538-.45-.915Z"
    />
  </svg>
)
export default SvgLightningBolt
